import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';

import { AddCreditCardDialogComponent } from '../add-credit-card-dialog/add-credit-card-dialog.component';
import { UpdateCreditCardDialogComponent } from '../update-credit-card-dialog/update-credit-card-dialog.component';
import { LowBalanceDialogComponent } from '../low-balance-dialog/low-balance-dialog.component';

import { AuthGuardService, DialogService, UserService } from '@core/services';

import { MdDialogFix } from '../md-dialog-fix';
import { Route, Router, RoutesRecognized, ActivatedRoute } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Component({
    selector: 'app-edit-credit-cards',
    templateUrl: './edit-credit-cards.component.html',
    styleUrls: ['./edit-credit-cards.component.css']
})
export class EditCreditCardsComponent implements OnInit {

    user: any;
    selectedOption: string;
    subscription: Subscription;
    cardsFound = true;
    courtesyAccount = false;
    fromConfirmPayment = false;

    constructor(private _userService: UserService,
        private _authGuard: AuthGuardService,
        private _dialogService: DialogService,
        private dialog: MatDialog,
        private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            console.log('params:',params);
            if (params && params.fromConfirmPayment) {
                this.fromConfirmPayment = params.fromConfirmPayment;
            }
        });
        this.subscription = this._userService.getUser().subscribe(user => {
            this.user = user;
            this.courtesyAccount = this.user.email.startsWith("dwt") && this.user.email.includes("@dwtunnel.com") && this.user.email.replace(/[^0-9]/g,"").length == 6;
        });
          this._authGuard.getCreditCards();

    }

    deleteCard(index: number) {
        this.openDeleteDialog(index);
    }

    editCard(index: number) {

        const dialogRef = this.dialog.open(UpdateCreditCardDialogComponent, {
        });
        dialogRef.componentInstance.cardIndex = index;

        // Needed to fix dialog opening closing issue on older iOS devices
        dialogRef.afterOpen().subscribe(MdDialogFix);

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            this.selectedOption = result;
            if (result) {
                this._authGuard.getCreditCards();
                this.checkAccountBalance();
            }
        });
    }

    addCard() {
        console.log('Adding card dialog');
        const dialogRef = this.dialog.open(AddCreditCardDialogComponent, {
            height: '500px',
            width: '400px',
        });

        // Needed to fix dialog opening closing issue on older iOS devices
        dialogRef.afterOpen().subscribe(MdDialogFix);

        dialogRef.afterClosed().subscribe(result => {
            this.selectedOption = result;
            if (result) {
                this._authGuard.getCreditCards();
            }
        });
    }

    openDeleteDialog(index) {
        this._dialogService.confirm('Delete Credit Card', 'Are you sure you want to delete this card?').subscribe(res => {
            console.log(res);
            if (res) {
                const deleteCardUrl = 'portfolios/DeleteCreditCard';
                let data: string;

                data = JSON.stringify({
                    'CreditCardId': this.user.creditCardArray[index].id,
                    'CustomerId': this.user.customerIdArray[this.user.customerIndex].Id
                });
                this._authGuard.authenticatedPost(deleteCardUrl, data).subscribe(
                    result => {
                        console.log('Deleted Card', this.user.creditCardArray[index].id);
                        this.user.deleteCreditCard(index);
                    },
                    error => console.log('Error: ' + error)
                );
            }
        })
    }

    updateCreditCardsArray() {
        this._authGuard.getCreditCards();
    }


    isPrimary(rawBool: boolean) {
        if (rawBool) {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    private checkAccountBalance() {
      if(this.user.accountSummaryArray[0].AccountBalance === 0) {
        let dialogRef = this.dialog.open(LowBalanceDialogComponent, {
          data: {
            message: 'Your account balance is below $5, please make a payment',
            alertType: 'danger',
            title: 'Low Account Balance'
          }
        });
      }
    }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/edit-credit-cards/edit-credit-cards.component.ts